import { tagFinderRegex } from '../constants';

export const extractUniqueTags = (text: string): string[] => {
    try {
        const match = [...text.matchAll(new RegExp(tagFinderRegex, 'g'))];
        // return unique in first group
        return [...new Set(match.flatMap(m => m[1]))];
    } catch (err) {
        throw new Error(`Could not extract tags: ${err}`);
    }
};
